import React, { useEffect, useState } from 'react';
import { text } from '../data';
import GreaseSelection from './grease-selection/GreaseSelection';
import InitialGreaseFill from './initial-grease-fill/InitialGreaseFill';
import GreaseRelubrication from './grease-relubrication/GreaseRelubrication';
import { TabData } from '../types/types';
import Tabs from '../components/Tabs';
import {getGreaseTabFromUrl} from "../utils/engineering-tools";

const GreaseLubrication: React.FC = () => {
	const tabs: TabData[] = [
		{
			id: 'grease_selection',
			title: text.greaseSelection,
			content: <GreaseSelection />,
		},
		{
			id: 'initial_grease_fill',
			title: text.initialGreaseFill,
			content: <InitialGreaseFill />,
		},
		{
			id: 'grease_relubrication',
			title: text.greaseRelubrication,
			content: <GreaseRelubrication />,
		},
	];

	const [ activeSearchTab, setActiveSearchTab ] = useState( tabs[ 0 ].id );

	const handleTabChange = ( id: string ) => {
		setActiveSearchTab( id );
	};

	return (
		<Tabs
			title={text.searchOptions}
			tabs={tabs}
			defaultTab={getGreaseTabFromUrl() ?? activeSearchTab}
			onChange={handleTabChange}
		/>
	);
};

export default GreaseLubrication;
